// extracted by mini-css-extract-plugin
module.exports = {"postedBy":"e_Clb","postedByDate":"e_Dlb","container":"e_Elb","description":"e_Flb","title":"e_Glb"};